import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getNativeCapabilities, isInWebView, postToNative } from "./nativeBridge";

const paths = new Set(["/", "/records", "/support"]);
export function useNativeMessengerNavigation(onOpenMenu: () => void) {
  const navigate = useNavigate();
  const [enabled, setEnabled] = useState(false);
  const [unread, setUnread] = useState({ count: 0, hasMore: false });
  useEffect(() => {
    function sync() {
      const supported = isInWebView() && getNativeCapabilities().supportsIntegratedMessenger === true;
      setEnabled(supported);
      if (supported) postToNative("native_messenger_ui_ready", { navigation: "franchisee" });
    }
    function onState(event: Event) {
      const detail = (event as CustomEvent).detail;
      if (!isInWebView() || getNativeCapabilities().supportsIntegratedMessenger !== true) return;
      const count = Number(detail?.unreadCount);
      if (Number.isSafeInteger(count) && count >= 0) setUnread({ count, hasMore: detail?.hasMore === true });
    }
    function onNavigation(event: Event) {
      if (!isInWebView() || getNativeCapabilities().supportsIntegratedMessenger !== true) return;
      const detail = (event as CustomEvent).detail;
      if (typeof detail?.path === "string" && paths.has(detail.path)) navigate(detail.path);
      if (detail?.openMenu === true) onOpenMenu();
    }
    window.addEventListener("cc_native_session_bootstrap", sync);
    window.addEventListener("cc_native_messenger_state", onState);
    window.addEventListener("cc_native_messenger_navigation", onNavigation);
    sync();
    return () => {
      window.removeEventListener("cc_native_session_bootstrap", sync);
      window.removeEventListener("cc_native_messenger_state", onState);
      window.removeEventListener("cc_native_messenger_navigation", onNavigation);
    };
  }, [navigate, onOpenMenu]);
  return { enabled, unreadCount: unread.count, unreadLabel: unread.count > 99 ? "99+" : `${unread.count}${unread.hasMore ? "+" : ""}`, open: () => postToNative("open_native_messenger", {}) };
}
